// src/lib/mindGarden/categoryCentroids.ts
// 8カテゴリそれぞれの「代表座標」を、LOGICAL_PLOT実座標の重心として算出する。
// ロジカル版以外のデッキの語は、この代表座標を基準に位置を借りる（橋渡し方式）。
// 2026-07-20作成。

import { LOGICAL_PLOT } from "@/constants/logicalPlot";
import { WORD_CATEGORY_MAP, WORD_CATEGORIES, type WordCategory } from "./wordCategories";

export interface CategoryCentroid {
  x: number;
  y: number;
  /** 重心算出に使ったロジカル版語数（0の場合はロジカル版に対象語が無いカテゴリ＝場面・情景／感嘆） */
  sampleCount: number;
}

function computeCategoryCentroids(): Record<WordCategory, CategoryCentroid> {
  const sums: Record<string, { x: number; y: number; n: number }> = {};
  for (const cat of WORD_CATEGORIES) sums[cat] = { x: 0, y: 0, n: 0 };

  for (const [word, coord] of Object.entries(LOGICAL_PLOT)) {
    const cat = WORD_CATEGORY_MAP[word];
    if (!cat) continue; // ロジカル版全語は分類済みのはずだが、念のためガード
    sums[cat].x += coord.x;
    sums[cat].y += coord.y;
    sums[cat].n += 1;
  }

  const result = {} as Record<WordCategory, CategoryCentroid>;
  for (const cat of WORD_CATEGORIES) {
    const s = sums[cat];
    result[cat] =
      s.n > 0
        ? { x: s.x / s.n, y: s.y / s.n, sampleCount: s.n }
        // 場面・情景／感嘆はロジカル版に対象語が無いため、原点付近をプレースホルダーにする。
        // 実データで検証が必要（未解決事項として記録済み）。
        : { x: 0, y: 0, sampleCount: 0 };
  }
  return result;
}

/** カテゴリごとの代表座標（モジュール読み込み時に一度だけ計算） */
export const CATEGORY_CENTROIDS: Record<WordCategory, CategoryCentroid> = computeCategoryCentroids();
